<template>
  <canvas id="cellCanvas" />
</template>

<script>
import { getRandomInts } from '../js/helpers.js';
import { timer } from 'd3-timer';


export default {
  props: {
    config: Object,
    numRows: Number,
    numCols: Number,
    dims: Object,
  },
  watch: {
    config() {
      this.updateCanvas();
    },
    dims() {
      this.resize();
      this.updateCanvas();
    },
  },
  methods: {
    resize() {
      const el = document.querySelector('#cellCanvas');
      el.height = this.dims.height;
      el.width = this.dims.width;

    },
    updateCanvas() {
      if (this.config.target === 'cells') {
        const x = getRandomInts(1, this.numCols);
        const y = getRandomInts(1, this.numRows);
        this.animateCells(x, y);
      }
    },
    animateCells(row, col) {
      const height = this.dims.height;
      const width = this.dims.width;

      // draw it first
      this.drawCell(width, height, row, col, 'draw');
      
      // wait and remove it
      const duration = getRandomInts(1000, 3000);
      const myTimer = timer(elapsed => {
        const t = Math.min(1, elapsed / duration);
        if (t === 1) { 
          this.drawCell(width, height, row, col, 'clear');
          myTimer.stop()
        }
      });
    },
    drawCell(width, height, row, col, type) {

      // get elements
      const canvas = document.querySelector('#cellCanvas');
      const ctx = canvas.getContext('2d');

      // setup
      ctx.save();

      // highlight cell
      const rowWidth = width / this.numCols;
      const colHeight = height / this.numRows;

      if (type === 'clear') {
        ctx.clearRect(row*rowWidth-2, col*colHeight-2, rowWidth+4, colHeight+4);
      } else if (type === 'draw') {
        ctx.beginPath();
        ctx.moveTo(row*rowWidth, col*colHeight);
        ctx.fillStyle = 'rgb(230, 0, 0, .5)';
        ctx.lineWidth = 3;
        ctx.fillRect(row*rowWidth, col*colHeight, rowWidth, colHeight);
        ctx.stroke();
      }

      // draw
      ctx.restore();
    },
  }
}
</script>


<style scoped lang='scss'>

</style>

